export enum TransactionalCreditPages {
  Form,
  Result,
}